import Confirm from "../Confirm";
import Modal from "../Modal";
import { splitDate, yearRange } from "src/utils";
import { ArrowDownIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import Input from "../Inputs/Input";
import Button from "../Inputs/Button";
import { BasicAnnuity } from "src/types";
const AnnuitySchedule = ({
  openYears,
  setOpenYears,
  setIncome,
  pension,
  settings,
  people,
}: {
  openYears: boolean;
  setOpenYears: (open: boolean) => void;
  setIncome: (income: BasicAnnuity) => void;
  pension: any;
  settings: any;
  people: any[];
}) => {
  const [resetOpen, setResetOpen] = useState(false);

  return (
    <Modal isOpen={openYears} onClose={() => setOpenYears(false)}>
      <div className="w-[500px]">
        <div className="mb-3 font-semibold text-lg ">Annuity schedule</div>
        <Confirm
          isOpen={resetOpen}
          onClose={() => setResetOpen(false)}
          onConfirm={() => {
            setIncome({ ...pension, startAmounts: {}, scheduleIncrease: null });
            setResetOpen(false);
          }}
        >
          Are you sure you want to reset the whole annuity schedule?
        </Confirm>
        <div className="flex justify-center w-[500px]">
          <div className="mb-4">
            <div className="flex justify-between items-end w-[500px]">
              <div className="relative">
                <Input
                  vertical
                  label="Yearly Increase"
                  labelLength={115}
                  subtype={pension.scheduleIncreaseType || "money"}
                  width="w-[150px]!"
                  value={pension.scheduleIncrease}
                  setValue={(v) =>
                    setIncome({ ...pension, scheduleIncrease: v })
                  }
                />
                <div
                  className="absolute top-[28px] right-[9px] text-black flex cursor-pointer"
                  onClick={() => {
                    setIncome({
                      ...pension,
                      scheduleIncreaseType:
                        pension.scheduleIncreaseType === "percent"
                          ? "money"
                          : "percent",
                    });
                  }}
                >
                  <div
                    className={`${pension.scheduleIncreaseType == "percent" ? "bg-main-orange text-white" : "bg-gray-200 text-black"} rounded-l px-1 py-[2px]`}
                  >
                    %
                  </div>
                  <div
                    className={`${pension.scheduleIncreaseType != "percent" ? "bg-main-orange text-white" : "bg-gray-200 text-black"} rounded-r px-1 py-[2px]`}
                  >
                    $
                  </div>
                </div>
              </div>

              <div
                className="text-black text-sm flex cursor-pointer"
                onClick={() => {
                  setIncome({
                    ...pension,
                    scheduleMoYr:
                      pension.scheduleMoYr === "annual" ? "monthly" : "annual",
                  });
                }}
              >
                <div
                  className={`${pension.scheduleMoYr === "monthly" ? "bg-main-orange text-white" : "bg-gray-200 text-black"} rounded-l px-3 py-[9px]`}
                >
                  Monthly
                </div>
                <div
                  className={`${pension.scheduleMoYr === "annual" ? "bg-main-orange text-white" : "bg-gray-200 text-black"} rounded-r px-3 py-[9px]`}
                >
                  Annual
                </div>
              </div>
              <div className="w-[150px]">
                <Button type="secondary" onClick={() => setResetOpen(true)}>
                  Reset Schedule
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col max-h-[570px] overflow-scroll gap-2 mb-4">
          <table className="border bg-white text-sm! w-full">
            <thead
              className={`text-xs cursor-pointer print:static bg-[#F9FAFB] text-black font-medium text-left sticky z-50 print:border-transparent print:border-b-gray-500 print:border-2 border  border-separate`}
            >
              <tr>
                <th className={`px-2 py-[0.45rem] font-medium text-black`}>
                  Year
                </th>
                <th className={`px-2 py-[0.45rem] font-medium text-black`}>
                  Ages
                </th>
                <th className={`px-2 py-[0.45rem] font-medium text-black`}>
                  Start Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {yearRange(0, settings.maxYearsShown).map((i, index) => (
                <tr
                  className={`${index % 2 == 1 ? "bg-[#F9FAFB]" : "bg-white"} border-y border-[#EAECF0] hover:bg-slate-100`}
                >
                  <td
                    className={`px-2 print:py-[0.2rem] py-[0.45rem] text-[#475467]
                              `}
                  >
                    {new Date().getFullYear() + i}
                  </td>
                  <td
                    className={`px-2 print:py-[0.2rem] py-[0.45rem] text-[#475467]
                              `}
                  >
                    {people
                      .map(
                        (p: any) =>
                          index +
                          new Date().getFullYear() -
                          splitDate(p.birthday).year,
                      )
                      .join("/")}
                  </td>
                  <td
                    className={`px-2 print:py-[0.2rem] py-[0.45rem] text-[#475467]
                              `}
                  >
                    <div className="flex  items-center">
                      <Input
                        label={``}
                        subtype="money"
                        onPaste={(_: any) => {}}
                        value={pension.startAmounts[i]}
                        width="h-[30px]! text-sm"
                        setValue={(value) =>
                          setIncome({
                            ...pension,
                            startAmounts: {
                              ...pension.startAmounts,
                              [i]: value,
                            } as any,
                          })
                        }
                      />
                      <div className=" ml-1 w-16">
                        {pension.scheduleMoYr === "monthly"
                          ? " / month"
                          : " / year"}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="w-12 ">
                      <Button
                        type="secondary"
                        onClick={() => {
                          setIncome({
                            ...pension,
                            startAmounts: Object.fromEntries(
                              yearRange(0, settings.maxYearsShown).map((k) => {
                                if (k > i) {
                                  if (
                                    pension.scheduleIncreaseType == "percent"
                                  ) {
                                    return [
                                      k,
                                      Math.round(
                                        pension.startAmounts[i] *
                                          Math.pow(
                                            1 + pension.scheduleIncrease / 100,
                                            k - i,
                                          ),
                                      ),
                                    ];
                                  } else {
                                    return [
                                      k,
                                      Math.round(
                                        pension.startAmounts[i] +
                                          pension.scheduleIncrease * (k - i),
                                      ),
                                    ];
                                  }
                                } else return [k, pension.startAmounts[k]];
                              }),
                            ) as any,
                          });
                        }}
                      >
                        <div className="flex items-center justify-center h-3 ">
                          <ArrowDownIcon className="w-3 h-3" />
                        </div>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Modal>
  );
};

export default AnnuitySchedule;
